import { app, payload } from "modular-openscriptjs";
import { routes } from "./backendRoutes";
import { api } from "./declarations";
const $e = app("$e");

/**
 * Sends event to the analytics mediator
 * @param {string} event
 * @param {*} params
 */
export function analyze(event, params = {}) {
    app("broker").send($e.analytics.needs.event, payload({ event, params }));
}

export class GoogleAnalytics {
    pageView(pageTitle) {
        analyze("page_view", {
            page_title: pageTitle,
            page_location: location.href,
        });
    }

    async orderConfirmed(orderId) {
        api.get(`${routes.orders}/${orderId}`).then((res) => {
            if (!res) {
                return;
            }

            let order = res.data.order;

            let items = [];

            for (let item of order.items) {
                let tmp = {};

                tmp.item_id = item.id;
                tmp.quantity = item.quantity ?? 1;
                tmp.price = item.total_paid;
                tmp.item_name = item.versioned_buyable?.name ?? "Unknown";

                items.push(tmp);
            }

            let payments = [];

            for (let payment of order.payments) {
                payments.push({
                    amount: payment.amount,
                    currency: payment.currency,
                    transaction_id: payment.transaction_id,
                    status: payment.status,
                });
            }

            analyze("order_confirmed", {
                price: order.total_paid,
                currency: userCurrency,
                items,
                payments,
            });
        });
    }

    async orderCancelled(orderId) {
        api.get(`${routes.orders}/${orderId}`).then((res) => {
            if (!res) {
                return;
            }

            let order = res.data.order;

            let items = [];

            for (let item of order.items) {
                let tmp = {};

                tmp.item_id = item.id;
                tmp.quantity = item.quantity;
                tmp.name = item?.versioned_buyable?.name;
                tmp.price = item?.total_paid;

                items.push(tmp);
            }

            let payments = [];

            for (let payment of order.payments) {
                payments.push({
                    amount: payment.amount,
                    currency: payment.currency,
                    transaction_id: payment.transaction_id,
                    status: payment.status,
                });
            }

            analyze("order_cancelled", {
                price: order.total_paid,
                currency: userCurrency,
                items,
                payments,
            });
        });
    }
}
